import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";
import { Badge } from "react-bootstrap";
import fallbackTranslation from "@/lib/dbTranslations";
// ICONS
import { DeleteIconCross } from "@/public/icons/icons";
// STYLE
import { useApp } from "@/components/context/AppContext/AppContext";
interface CustomBadge {
  handleRemove: any;
  type: string;
  value: any;
}

export default function CustomBadge({ handleRemove, type, value }: CustomBadge) {
  const app = useApp();
  const router = useRouter();

  const valueObj = app.appConfig[type] && app.appConfig[type].find((el) => el.key == value);

  const { t } = useTranslation(["common", "db-translations"]);

  return (
    <Badge
      bg="white"
      pill
      className="pe-1"
      style={{
        border: "2px solid",
        borderColor: type == "colors" ? valueObj?.value : "black",
        paddingRight: "1rem",
        display: "inline-flex",
        alignItems: "center",
        backgroundColor: "white",
      }}
    >
      <span className="text-black fs-6 fw-semibold px-2">{fallbackTranslation(type, "db-translations", valueObj, t, router.locale)}</span>
      <div style={{ cursor: "pointer" }} onClick={() => handleRemove(type, valueObj.key)}>
        <DeleteIconCross width={18} height={18} color="black" />
      </div>
    </Badge>
  );
}
